var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("spinner", {
            attrs: {
              size: "80",
              "line-size": 12,
              "line-fg-color": "grey",
              "line-bg-color": "lightgrey",
              speed: 1.5
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.poa && !_vm.loading
        ? _c("div", { staticClass: "mt-4" }, [
            _vm._v(
              _vm._s(_vm.$t("message.accountPowerOfAttorneyForm.pleaseUpload"))
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.poa
        ? _c(
            "div",
            [
              _c("b-btn", { on: { click: _vm.onPrintPoaFn } }, [
                _c("span", { staticClass: "ti-printer" }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-2" }, [_vm._v("|")]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.fullName) +
                    " " +
                    _vm._s(
                      _vm.$t("message.accountPowerOfAttorneyForm.btn.printPoa")
                    ) +
                    "\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.poa
        ? _c(
            "div",
            [
              _c(
                "b-btn",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.revoke_poa",
                      modifiers: { revoke_poa: true }
                    }
                  ],
                  staticClass: "mt-4 text-muted font-weight-light p-0",
                  attrs: { variant: "link" }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "message.accountPowerOfAttorneyForm.btn.revokePoa"
                        )
                      ) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.poa && !_vm.loading
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c("b-col", { staticClass: "text-right" }, [
                    _c("label", { staticClass: "btn btn-primary mb-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "message.accountPowerOfAttorneyForm.btn.browse"
                            )
                          ) +
                          "\n          "
                      ),
                      _c("input", {
                        attrs: {
                          type: "file",
                          hidden: "",
                          accept: "application/pdf, image/*"
                        },
                        on: { change: _vm.uploadPoa }
                      })
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "revoke_poa",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.accountPowerOfAttorneyForm.title"),
            "ok-title": _vm.$t("message.accountPowerOfAttorneyForm.btn.ok"),
            "cancel-title": _vm.$t(
              "message.accountPowerOfAttorneyForm.btn.cancel"
            )
          },
          on: { ok: _vm.revoke }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.accountPowerOfAttorneyForm.message")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44ac6303", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ac6303","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPowerOfAttorneyForm.vue
// module id = AE6e
// module chunks = 1